import React, { useEffect, useState, useRef } from "react";
import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import VehicleTransferRequestService from "../services/vehicleTransferService";
import ProjectService from "../services/ProjectService";
import Breadcrumb from "../components/Breadcrumb";
import StorageService from "../services/StorageService";
import VehicleTypeService from "../services/VehicleTypeService";
import MessageDialog from "../components/MessageDialog";


export default function AddVehicleTransfer() {
  const [isEdit, setIsEdit] = useState(false);
  const [projects, setProjects] = useState([]);
  const [vehicleTypes, setVehicleTypes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [msgType, setMsgType] = useState("error");
  const [dateError, setDateError] = useState(""); 
  // const messageTimer = useRef(null);
  const navigate = useNavigate();
  const { id } = useParams();

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    watch, 
  } = useForm();

  const showMessage = (text, type = "error") => {
    setMessage(text);
    setMsgType(type);
    // if (messageTimer.current) clearTimeout(messageTimer.current);
    // messageTimer.current = setTimeout(() => setMessage(""), 4000);
  };

  
  useEffect(() => {
    const loadDropdowns = async () => {
      try {
        const companyId = StorageService.activeCompany().companyId;
        const employeeId = StorageService.loginData()?.employeeId;

        let projRes;
        if (employeeId) {
          projRes = await ProjectService.getActiveProjectsByEmployee(companyId, employeeId);
        } else {
          projRes = await ProjectService.getActiveProjectsByCompany(companyId);
        }
        const projectData = projRes?.data || projRes || [];

const mappedProjects = projectData.map(p => ({
  id: p.id || p.projectId,
  projectName: p.projectName,
  projectCode: p.projectCode
}));

setProjects(mappedProjects);


        
        const vehicleTypesRes = await VehicleTypeService.getActiveVehicleTypes();
        setVehicleTypes(vehicleTypesRes?.data || vehicleTypesRes || []);

      } catch (err) {
        console.error("Error loading dropdowns:", err);
      }
    };

    loadDropdowns();
  }, []);


  useEffect(() => {
    if (!isEdit) {
      const today = new Date().toISOString().split("T")[0];
      setValue("startDate", today);
    }
  }, [isEdit, setValue]);

  
  useEffect(() => {
    const loadData = async () => {
      try {
        const companyId = StorageService.activeCompany().companyId;
        const employeeId = StorageService.loginData()?.employeeId;

        let projRes;
        if (employeeId) {
          projRes = await ProjectService.getActiveProjectsByEmployee(companyId, employeeId);
        } else {
          projRes = await ProjectService.getActiveProjectsByCompany(companyId);
        }
        setProjects(projRes?.data || projRes || []);

        const vehicleTypesRes = await VehicleTypeService.getActiveVehicleTypes();
        setVehicleTypes(vehicleTypesRes?.data || vehicleTypesRes || []);

        if (id) {
          setIsEdit(true);
          const res = await VehicleTransferRequestService.getById(id);
          const record = res?.data || res;

          setValue("projectId", record.projectId || "");
          setValue("vehicleTypeId", record.vehicleTypeId || "");
          setValue("startDate", record.startDate?.split("T")[0] || "");
          setValue("endDate", record.endDate?.split("T")[0] || "");
        }
      } catch (err) {
        console.error("Error loading page:", err);
        showMessage("Error loading page", "error");
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, [id, setValue]);

  
  const startDate = watch("startDate");
  const endDate = watch("endDate");

  useEffect(() => {
    const today = new Date().toISOString().split("T")[0];

    if (!isEdit && startDate && startDate < today) {
      setDateError("Start Date cannot be in the past");
      return;
    }

    if (startDate && endDate) {
      if (endDate < startDate) {
        setDateError("End Date must be greater than or equal to Start Date");
      } else {
        setDateError("");
      }
    } else {
      setDateError("");
    }
  }, [startDate, endDate, isEdit]);

  
  const onSubmit = async (data) => {
    setLoading(true);

    
    if (dateError) {
      showMessage(dateError, "error");
      setLoading(false);
      return;
    }

    try {
      const companyId = StorageService.activeCompany().companyId;
      data.companyId = companyId;

      const today = new Date().toISOString().split("T")[0];

      if (!isEdit) {
       
        data.requestedDate = today;
        data.requestedBy = StorageService.loginData().employeeId;

        data.status = "Pending";       
        data.approvedBy = null;
        data.approvedDate = null;
        data.rejectedBy = null;
        data.rejectedDate = null;
      }

      if (isEdit) {
        data.updatedBy = StorageService.loginData().employeeId;
        await VehicleTransferRequestService.update(id, data);
        showMessage("Vehicle Transfer updated successfully!", "success");
      } else {
        data.createdBy = StorageService.loginData().employeeId;
        await VehicleTransferRequestService.create(data);
        showMessage("Vehicle Transfer added successfully!", "success");
      }

      setTimeout(
        () => navigate("/cpnl/vehicletransfer/view", { state: { refresh: true } }),
        1000
      );

    } catch (error) {
      console.error(error);
      showMessage("Failed to save vehicle transfer", "error");
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => navigate("/cpnl/vehicletransfer/view");

  return (
    <>
      <Breadcrumb
        pageTitle={isEdit ? "Modify Vehicle Transfer" : "Add Vehicle Transfer"}
        secondTitle="Vehicle Management"
      />
      
      {/* {message && (
        <div className={`alert alert-${msgType === "error" ? "danger" : "success"}`}>
          {message}
        </div>
      )} */}
        <MessageDialog
          message={message}
          type={msgType}
          setMessage={setMessage}
          setMsgType={setMsgType}
        />
      
      <div className="card p-4 bg-white shadow-sm">
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="row">

            {/* PROJECT DROPDOWN */}
            <div className="mb-3 col-md-6">
              <label className="form-label">
                Project <span className="text-danger">*</span>
              </label>
              <select
                className="form-select"
                {...register("projectId", { required: "Project is required" })}
              >
                <option value="">Select Project</option>
                {projects.map((p) => (
                  <option key={p.id} value={p.id}>{p.projectName} - {p.projectCode}</option>
                ))}
              </select>
              {errors.projectId && (
                <small className="text-danger">{errors.projectId.message}</small>
              )}
            </div>

            {/* VEHICLE TYPE DROPDOWN */}
            <div className="mb-3 col-md-6">
              <label className="form-label">
                Vehicle Type <span className="text-danger">*</span>
              </label>
              <select
                className="form-select"
                {...register("vehicleTypeId", {
                  required: "Vehicle type is required",
                })}
              >
                <option value="">Select Vehicle Type</option>
                {vehicleTypes.map((v) => (
                  <option key={v.id} value={v.id}>{v.vehicleType}</option>
                ))}
              </select>
              {errors.vehicleTypeId && (
                <small className="text-danger">{errors.vehicleTypeId.message}</small>
              )}
            </div>
          </div>

          {/* DATES */}
          <div className="row">
            <div className="mb-3 col-md-6">
              <label className="form-label">Start Date</label>
              <input
                type="date"
                className="form-control"
                min={!isEdit ? new Date().toISOString().split("T")[0] : undefined}
                {...register("startDate")}
              />
            </div>

            <div className="mb-3 col-md-6">
              <label className="form-label">End Date</label>
              <input
                type="date"
                className="form-control"
                min={startDate || (!isEdit ? new Date().toISOString().split("T")[0] : undefined)}
                {...register("endDate")}
              />
              {dateError && <small className="text-danger">{dateError}</small>}
            </div>
          </div>

          {/* BUTTONS */}
          <button className="btn btn-primary me-2" type="submit" disabled={loading}>
            {loading ? (isEdit ? "Updating..." : "Saving...") : isEdit ? "Update" : "Save"}
          </button>

          <button type="button" className="btn btn-secondary" onClick={handleCancel}>
            Cancel
          </button>
        </form>
      </div>
    </>
  );
}
